import React, { Component } from "react";
import { userService } from "../../../_services/user.service";
import EditSheet from "./EditSheet";
import PricingSheetCard from "./PricingSheetCard";
class PricingSheetModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEditPopup: false,
            pricingSheetData: [],
            sheetEditData: ''
        }
    }
    componentDidMount() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getPricingSheets(Usermeta_Data.split(':')[0]);
    }
    getPricingSheets(UserId) {
        try {
            userService.FetchPricingSheets(UserId).then((apiData) => {
                if (apiData && apiData.length > 0) {
                    this.setState({ pricingSheetData: apiData });
                }
            })
        } catch (err) {
        }
    }
    editSheet(sheetData) {
        this.setState({ sheetEditData: sheetData, showEditPopup: true })
    }
    hideEditSheetPopup() {
        this.setState({ sheetEditData: '', showEditPopup: false })
    }

    changeInSheet() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getPricingSheets(Usermeta_Data.split(':')[0]);
    }

    render() {
        return (
            <div className="training_section add-tooltip">
                <div>
                    <div className="training-header">
                        <h3>Pricing Sheets</h3>
                    </div>
                    <div className="training-content">
                        <div className="training-videos">
                            {this.state.pricingSheetData && this.state.pricingSheetData.length ? this.state.pricingSheetData.map((item, index) =>
                                <PricingSheetCard key={index} sheetData={item}
                                    editSheet={() => this.editSheet(item)}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
                {this.state.showEditPopup && <EditSheet sheetData={this.state.sheetEditData} hideModal={() => this.hideEditSheetPopup()} changeInSheet={() => this.changeInSheet()} />}
            </div>
        )
    }
}
export default PricingSheetModule;